export enum ChatMessageKind {
  Answer = 0,
  Report = 1,
}
